import { render, staticRenderFns } from "./ResizableElement.vue?vue&type=template&id=6a62bad8&scoped=true&"
import script from "./ResizableElement.vue?vue&type=script&lang=ts&"
export * from "./ResizableElement.vue?vue&type=script&lang=ts&"
import style0 from "./ResizableElement.vue?vue&type=style&index=0&id=6a62bad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a62bad8",
  null
  
)

export default component.exports